import { render } from "./SDNComponentUpdateForm.vue?vue&type=template&id=45550258"
import script from "./SDNComponentUpdateForm.vue?vue&type=script&lang=js"
export * from "./SDNComponentUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-content-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__